export const addresses = {
  tokenGate: "0x025B85c8071E4ab4A91c1D541Ed1fE99D6cAd04F",
};
